<template>
  <div id="destinations" class="d-block">
    <div class="top-banner" data-aos="fade-up" data-aos-duration="900">
      <div class="image-gradient-bottom"></div>
      <div class="top-banner-content">
        <p :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">Nos destinations</p>
        <p class="merriweather-reg-18">Chaque destination vous réserve des <span class="merriweather-light-italic-24">privilèges exceptionnels</span></p>
      </div>
    </div>
    <div>
      <Regionsmasonry :destinations="destinations" v-if="destinations && !isLoading"></Regionsmasonry>
      <ClubHortensePhone v-if="isPhone && destinations && !isLoading" class="pt-5 pb-5"/>
      <ClubHortense v-else-if="destinations && !isLoading" class="pt-5 pb-5"/>
      <OtherRegions :destinations="destinations" v-if="destinations && !isLoading" :class="isPhone ? '' : 'pt-5'"/>
      <CoupsDeCoeurDestinations :user="user" v-if="destinations && !isLoading" class="pt-5"/>
      <ExperienceDestinations :destinations="destinations" v-if="destinations && !isLoading" class="pt-5"/>
      <DestinationsInfo v-if="destinations && !isLoading" class="pt-5"/>
    </div>
  </div>
</template>

<script>
import HeadDesti from "./HeadDesti.vue";
import Francecard from "./Francecard.vue";
import ScrollUp from "components/btns/ScrollUp.vue";
import fetcher from "packs/shared/api.js";
import Searchbtn from "components/btns/Searchbtn.vue";
import Searchbanner from "components/btns/Searchbanner.vue";
import Regionsmasonry from "./Regionsmasonry.vue";
import ClubHortense from "components/ClubHortense.vue";
import OtherRegions from "./OtherRegions.vue";
import ClubHortensePhone from "components/ClubHortensePhone.vue";
import CoupsDeCoeurDestinations from "./CoupsDeCoeurDestinations.vue";
import DestinationsInfo from "./DestinationsInfo.vue";
import Experience from "../../pages/clubs/Experience.vue";
import ExperienceDestinations from "./ExperienceDestinations.vue";

export default {
  name: "destinations",
  components: { HeadDesti, ScrollUp, Francecard, Searchbtn, Searchbanner, Regionsmasonry, ClubHortense, OtherRegions, ClubHortensePhone, CoupsDeCoeurDestinations, DestinationsInfo, ExperienceDestinations },
  props: {
    user: Object
  },
  data() {
    return {
      showBanner: false,
      destinations: null,
      isLoading: true,
      isPhone: window.innerWidth <= 768
    };
  },
  methods: {
    async fetchDestinations() {
      try {
        const response = await fetcher.get('/destination', {
          params: { countries: ['FRANCE', 'OCÉAN INDIEN', 'CARAÏBES', 'AFRIQUE', 'EUROPE'] }
        });
        this.destinations = response.data;
        this.isLoading = false;
      } catch (e) {
        console.error(e);
      }
    },
  },
  mounted() {
    this.fetchDestinations();
    const navbarItems = document.querySelectorAll('.bm-burger-bars');

    navbarItems.forEach((bar) => {
      bar.style.color = 'white';
      bar.style.backgroundColor = 'white';
      bar.style.border = '0.5px solid white';
    });
  },
};
</script>
<style
  lang="scss"
  scope="app/assets/stylesheets/components/destinations"
></style>

<style scoped lang="scss">
.top-banner {
  height: 399px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-destination.png');
  background-size: cover;

  @media screen and (max-width: 768px) {
    height: 503px;
  }

  .top-banner-content {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
  }

  .image-gradient-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 115%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
    pointer-events: none;
  }
}
</style>